export class TransitRequestCustomDTO {
    Id?: number;

    RequestId?: string; // Guid → string

    AppInstanceId?: string; // Guid → string

    StepId?: number;

    ComponentURL?: string;

    CompletedBy?: string;

    StepData?: string; // JSON stored as string

    // Order?: number;

    // ActivityInstanceID?: number;

    IsAdmin?: boolean;

    IsEstimatedFeesPaid?: boolean;

    PaymentStatus?: number;

    IsPaymentRefunded?: boolean;

    IsVesselTransited?: boolean;

    LimitTimeRate?: number;

    IsArrived?: boolean;

    DirectionId?: number;

    ActualTransitDate: Date;

    TransitType: number;

    GuaranteeType?: number;

    MaxValueNetTonnage?: number;

    AgentId?: string;
    
    ConvoyDate?: Date;

    RequestApprovedLimitRate : string;
}
